import {
    PersonIcon,
    UpdateIcon,
} from '@radix-ui/react-icons';
import { useCallback, useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from '../ui/use-toast';

function DeleteUserGDPRDataDialog() {

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [email, setEmail] = useState('');
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleChange = async (e) => {
        e.preventDefault();
        if (isLoading) return;

        setIsLoading(true);
        setError(null);

        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/users/redact`, {
                email
            });
            toast({
                title: 'Personuppgifter raderade',
                description: `Personuppgifter för användare med e-post ${email} har raderats.`,
            });
            setIsDialogOpen(false);
        } catch (error) {
            setError(error?.response?.data?.error);
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleValueChange = useCallback((e) => {
        setEmail(e.target.value);
    }, []);

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full text-destructive' variant='destructive'>
                    <PersonIcon className='mr-3'/>
                    Radera personuppgifter
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>Radera personuppgifter</DialogTitle>
                    <DialogDescription>Ange en användares e-postadress för att radera personuppgifter ur systemet. <br /><br />Användarens personuppgifter, så som namn, e-postadress med mera, kommer att ersättas med fyllnadsvärden. Personen kommer inte längre vara synlig i föreningens medlemsregister och kommer därför inte inkluderas i medlemsdataexporten. Om användaren är anmäld till en tävling måste arrangören ta bort ekipaget eller byta förare manuellt i efterhand. Användarens kaniner kommer dock att finnas kvar i systemet och kan vid behov överföras till en ny huvudförare av en superadmin.<br /><br /><b className='text-foreground'>Observera att denna handling inte ångras, detta är sista varningen!</b></DialogDescription>
                </DialogHeader>
                <div className="flex flex-col gap-2">
                    <Label htmlFor='email'>Användarens e-postadress</Label>
                    <Input
                        id='email'
                        type='email'
                        autoComplete='off'
                        placeholder='hej@cmdigital.se'
                        value={email}
                        onChange={handleValueChange}
                    />
                </div>
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button type="submit" variant='destructive' onClick={handleChange} disabled={isLoading}>
                        {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Radera användare</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteUserGDPRDataDialog;
